import {appInstance} from '@/utils/app-accessor'
import {authStore} from '@/composables/store-accessor'

export default defineNuxtRouteMiddleware(() => {
    const companyType = authStore.companyType

    if (companyType !== 'TOUR_OPERATOR_1LEVEL') {
        throw createError({statusCode: 403, message: appInstance.$i18n.t('error_message.forbidden')})
    }
})
